// extracted by mini-css-extract-plugin
export default {"appear":"lottie_appear__nb1R-","appearActive":"lottie_appearActive__HdXSR"};